import { render } from "./RankingTable012.vue?vue&type=template&id=104006ea&scoped=true"
import script from "./RankingTable012.vue?vue&type=script&lang=js"
export * from "./RankingTable012.vue?vue&type=script&lang=js"

import "./RankingTable012.vue?vue&type=style&index=0&id=104006ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104006ea"]])

export default __exports__